







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import siteService from '@/project/site/site.service';

import { init as vueAirBnbInit, activeDatePicker } from './vue-airbnb-style-datepicker.service';

interface AirBnbDatepicker extends Vue {
    closeDatepicker: () => void,
    openDatepicker: () => void
}

@Component
export default class DatePicker extends Vue {
    internalDate1: string | null = null;
    internalDate2: string | null = null;
    id = `${Math.round(Math.random() * 10000)}-${new Date().valueOf()}`;
    initialized = false;

    @Prop({
        type: String,
        default: 'single',
        validator: value => ['single', 'range'].includes(value as string)
    })
    mode!: 'single' | 'range';

    @Prop(Date)
    value!: Date | null;

    @Prop(Date)
    date1!: Date | null;

    @Prop(Date)
    date2!: Date | null;

    @Prop(Date)
    minDate!: Date | null;

    @Prop(Date)
    maxDate!: Date | null;

    @Prop({ type: Boolean, default: false })
    startOpen!: boolean;

    @Prop({ type: Boolean, default: false })
    fullscreenMobile!: boolean;

    @Prop({ type: Boolean, default: false })
    ctaFull!: boolean;

    @Prop({ type: String, default: '' })
    text!: string;

    get activeDatePickerId(): string | null {
        return activeDatePicker.id;
    }

    set activeDatePickerId(id: string | null) {
        activeDatePicker.id = id;
    }

    get mobileHeader() {
        return this.fullscreenMobile ? ' ' : null; // for now, add empty text to remove header on mobile
    }

    async created() {
        await vueAirBnbInit();
        this.initialized = true;
    }

    destroyed() {
        if (this.activeDatePickerId === this.id) {
            this.activeDatePickerId = null;
        }
    }

    @Watch('value', { immediate: true })
    onValueChange(value: Date | null, oldValue: Date | null) {
        this.internalDate1 = value ? this.dateToIso(value) : null;
    }

    @Watch('date1', { immediate: true })
    onDate1Change(value: Date | null) {
        if (value) {
            this.internalDate1 = this.dateToIso(value);
        }
    }

    @Watch('date2', { immediate: true })
    onDate2Change(value: Date | null) {
        if (value) {
            this.internalDate2 = this.dateToIso(value);
        }
    }

    @Watch('activeDatePickerId')
    onActiveDatePickerIdChanged(id: string | null) {
        if (id !== this.id) {
            this.closeDatepicker();
        }
    }

    dateOneSelected(isoDate: string):void {
        const date = new Date(isoDate);
        this.$emit('input', date);
        this.$emit('update:date1', date);
    }

    dateTwoSelected(isoDate: string):void {
        const date = new Date(isoDate);
        this.$emit('update:date2', date);
    }

    dateToIso(date: Date | null): string | null {
        if (!date || !this.isValidDate(date)) return null;
        return date.toISOString().split('T')[0];
    }

    isoDateToString(date: string): string {
        return new Date(date).toLocaleDateString(siteService.getCulture() || '');
    }

    get selectedDates() {
        let formattedDates = '';
        if (this.internalDate1) {
            formattedDates = this.isoDateToString(this.internalDate1);
        }
        if (this.internalDate2) {
            formattedDates += ' - ' + this.isoDateToString(this.internalDate2);
        }
        return formattedDates;
    }

    isValidDate(d: Date) {
        return d instanceof Date && !isNaN(d as any);
    }

    $refs!: {
        datepicker: AirBnbDatepicker
    }

    openDatepicker() {
        if (this.$refs.datepicker) {
            this.$refs.datepicker.openDatepicker();
            this.activeDatePickerId = this.id;
        }
    }

    closeDatepicker() {
        if (this.$refs.datepicker) {
            this.$refs.datepicker.closeDatepicker();

            if (this.activeDatePickerId === this.id) {
                this.activeDatePickerId = null;
            }
        }
    }
}
